import { memo } from 'react';
import styled from 'styled-components/macro';
import { bool, oneOf } from 'prop-types';
import { compare as compareColors } from 'styles/themes/colors';
import { SVG } from './style';

const InnerCircle = styled.circle`
  transition: 80ms transform linear, 80ms opacity linear;
`;

/**
 * A simple SVG circle indicating an (in)active state
 *
 * @method      Indicator
 * @param       {Object}  props React props
 * @param       {Boolean} props.active Should this indicator display the active state?
 * @param       {String}  props.color In what color should this indicator render?
 * @constructor
 */
function Indicator(props) {
  const { active, color } = props;

  return (
    <SVG width="24" height="24" viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
        fill="white"
      />
      <InnerCircle
        cx="12"
        cy="12"
        r="6"
        stroke="none"
        fill={color}
        active={active}
        transform={`translate(12, 12) scale(${
          active ? 1 : 0
        }) translate(-12, -12)`}
      />
    </SVG>
  );
}

Indicator.propTypes = {
  active: bool.isRequired,
  color: oneOf(Object.values(compareColors)).isRequired,
};

export default memo(Indicator);
